import { Typography, Stack, Paper, Box } from '@ace-clublabs/shared-component-library';
import {
  UpgradeBenefitIWT,
  ChangeAddressIWT,
  ManageAutopayIWT,
  ManageSavedPaymentMethodsIWT,
  ManageCommunicationPreferenceIWT,
  GiftMembershipIWT,
} from './IWTs';
import { ManageMembershipIWT } from './IWTs/ManageMembershipIWT';
import { useEffect, useRef, useState } from 'react';

export const MembershipIWTs = () => {
  const boxRef = useRef<HTMLElement>(null);
  const [boxHeight, setBoxHeight] = useState('340px');

  const updateBoxHeight = () => {
    if (boxRef.current) {
      const height = boxRef.current.offsetHeight; // Measure the height of the box container
      setBoxHeight(`${height}px`); // Set the box background height to the size of the container
    }
  };

  useEffect(() => {
    updateBoxHeight();

    window.addEventListener('resize', updateBoxHeight);

    return () => {
      window.removeEventListener('resize', updateBoxHeight);
    };
  }, []);

  return (
    <div className="membership-iwts-section">
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          right: 0,
          zIndex: -1,
          width: '100vw',
          height: boxHeight,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#F7F5F1',
          alignItems: 'center',
          '@media (min-width: 768px)': { backgroundColor: 'white' },
        }}
      />
      <Paper
        ref={boxRef}
        sx={{
          width: '100% !important',
          maxWidth: '554px',
          padding: '0',
          marginTop: '30px',
          backgroundColor: '#F7F5F1',
          '@media (min-width: 768px)': { width: '391px' },
        }}
      >
        <Stack
          id="membership-iwts"
          direction={'column'}
          gap={'8px'}
          flexWrap="wrap"
          sx={{
            maxWidth: '475px',
            padding: '12px 16px',
          }}
        >
          <Typography variant="h5" sx={{ marginBottom: '16px' }} className="membership-iwt-title">
            I want to...
          </Typography>
          <Stack id="membership-iwts" direction={'row'} flexWrap="wrap">
            <UpgradeBenefitIWT />
            <ManageMembershipIWT />
            <ChangeAddressIWT />
            <ManageAutopayIWT />
            <ManageSavedPaymentMethodsIWT />
            <ManageCommunicationPreferenceIWT />
            <GiftMembershipIWT />
          </Stack>
        </Stack>
      </Paper>
    </div>
  );
};
